
export const getters = {
  account: state => state.account,
  accounts: state => state.accounts
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/account/getters.js